import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  WritableSignal,
  signal,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { Insurance } from '@app/akita/api/products/models/insurance.model';
import { Product } from '@app/akita/api/products/models/product.model';
import { PopsyShield4IconComponent } from '@app/shared/components/icons/generated/popsy-shield-4/popsy-shield-4.component';
import { PictureComponent } from '@app/shared/components/picture/picture.component';
import { PriceModel } from '@app/shared/models/api/price.model';
import { AmountPipe } from '@app/shared/pipes/amount.pipe';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-checkout-order-summary-item',
  templateUrl: './checkout-order-summary-item.template.html',
  styleUrls: ['./checkout-order-summary-item.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    TranslocoModule,
    PictureComponent,
    AmountPipe,
    PopsyShield4IconComponent,
  ],
})
export class CheckoutOrderSummaryItemComponent implements OnChanges {
  @Input() public item?: Product | null = null;
  @Input() public quantity?: number | null = 1;
  @Input() public insurance?: Insurance | null = null;
  @Input() public loading?: boolean | null;
  @Input() public mobileMode?: boolean | null = false;

  public language: string;

  public insurancePrice: WritableSignal<PriceModel | null> = signal(null);

  constructor(private readonly translocoService: TranslocoService) {
    this.language = this.translocoService.getActiveLang();
    this.insurancePrice = signal(null);
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      this.insurancePrice?.set({
        amount: this.insurance?.price?.amount || 0,
        currency: this.insurance?.price.currency || 'SAR',
      });
    }
  }
}
